var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import api from '@/api'; //getAcroComponentListByCode
const SelectModal = ({ visible, onOk, onCancel, positions, initialSelectedItem, baseMark, selectedButton, }) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [dataList, setDataList] = useState([]); // 添加状态来存储接口数据
    useEffect(() => {
        if (initialSelectedItem) {
            setSelectedRowKeys([initialSelectedItem.code]);
            setSelectedRow(initialSelectedItem);
        }
        else {
            setSelectedRowKeys([]);
            setSelectedRow(null);
        }
        if (visible) {
            const fetchDeclaredDifficultyDetail = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const params = {
                        base_mark: baseMark,
                        code: selectedButton,
                    };
                    const res = yield api.CoachCardApi.getAcroComponentListByCode(params);
                    if (res.data && res.data.code === 200) {
                        const clearOption = { code: 'clear', dd: '', description: 'Clear this code' };
                        //如果是P1,P2，筛选出p1或者p2的数据
                        let PreaultData = res.data.data.options;
                        if (positions === 'P1') {
                            PreaultData = res.data.data.options.filter((item) => !item.code.includes('2'));
                        }
                        else if (positions === 'P2') {
                            PreaultData = res.data.data.options.filter((item) => item.code.includes('2'));
                        }
                        setDataList([clearOption, ...PreaultData]);
                    }
                }
                catch (error) {
                    setDataList([]);
                }
            });
            fetchDeclaredDifficultyDetail();
        }
        else {
            setDataList([]); // 弹窗关闭时清空数据
        }
    }, [initialSelectedItem, visible, selectedButton]); // 添加依赖项
    const columns = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: 'DD',
            dataIndex: 'dd',
            key: 'dd',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: '70%',
        },
    ];
    const rowSelection = {
        type: 'radio',
        selectedRowKeys,
        onChange: (keys, selectedRows) => {
            setSelectedRowKeys(keys);
            setSelectedRow(selectedRows.length > 0 ? selectedRows[0] : null);
        },
    };
    const handleOk = () => {
        onOk(selectedRow);
    };
    const handleCancel = () => {
        onCancel();
    };
    return (<Modal title="Select" visible={visible} onOk={handleOk} onCancel={handleCancel} width="70%" footer={[
            <Button key="cancel" onClick={handleCancel} icon={<CloseOutlined />}>
          Cancel
        </Button>,
            <Button key="ok" type="primary" onClick={handleOk} icon={<CheckOutlined />}>
          OK
        </Button>,
        ]}>
      <Table rowKey="code" rowSelection={rowSelection} columns={columns} dataSource={dataList} pagination={false} bordered size="small" scroll={{ y: 400 }} onRow={(record) => {
            return {
                onClick: () => {
                    setSelectedRowKeys([record.code]);
                    setSelectedRow(record);
                },
            };
        }}/>
    </Modal>);
};
export default SelectModal;
